import { Box, Button, Grid, MenuItem, Select } from "@mui/material";

import { Constants } from "./Constants";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
export const BackButton = (props) => {
  return (
    <>
      <Button
        disableElevation
        onClick={() => props.backRoute()}
        sx={props.styles}
        variant={Constants.VARIANT_CONTAINED}
      >
        {Constants.BUTTON_TEXT_BACK}
      </Button>
    </>
  );
};
export const SearchButton = (props) => {
  return (
    <>
      <Button
        type="submit"
        sx={props.styles.searchButton}
        variant={Constants.VARIANT_CONTAINED}
      >
        {Constants.BUTTON_TEXT_SEARCH}
      </Button>
    </>
  );
};
export const ClearButton = (props) => {
  return (
    <>
      <Button
        onClick={(e) => props.reset()}
        type="reset"
        sx={props.styles.searchButton}
        variant={Constants.VARIANT_CONTAINED}
      >
        {Constants.BUTTON_TEXT_CLEAR}
      </Button>
    </>
  );
};
export const SelectButton = (props) => {
  return (
    <>
      <Select
        value={props.rowsPerPage}
        autoWidth
        defaultValue={10}
        name="rowsPerPage"
        onChange={props.handleChangeRowsPerPage}
        size={Constants.FONT_SIZE_SMALL}
        sx={{
          background: "#EFEFEF",

          borderRadius: "8px",
        }}
        IconComponent={(props) => <ArrowDropDownIcon {...props} />}
      >
        {props.totalRowCount > 10 ? (
          Constants.PAGE_SIZE_ARRAY.map((value, index) => (
            <MenuItem
              onClick={() => {
                props.getList(props.page, value);
              }}
              value={value}
            >
              {value}
            </MenuItem>
          ))
        ) : (
          <MenuItem
            onClick={() => {
              props.getList(props.page, 10);
            }}
            value={10}
          >
            {10}
          </MenuItem>
        )}
      </Select>
    </>
  );
};
export const AddButton = (props) => {
  return (
    <>
      <Button
        onClick={props.route}
        sx={props.styles.addButton}
        variant={Constants.VARIANT_OUTLINED}
      >
        {props.text}
      </Button>
    </>
  );
};
export const AddEditFormButton = (props) => {
  return (
    <Box display={"flex"} alignItems={"center"} gap="10px">
      <Button
        onClick={props.route}
        sx={props.styles}
        variant={Constants.VARIANT_OUTLINED}
        disableElevation
      >
        {Constants.BUTTON_TEXT_CANCEL}
      </Button>

      <Button
        type="submit"
        sx={props.styles}
        disableElevation
        variant={Constants.VARIANT_CONTAINED}
        {...props}
      >
        {Constants.BUTTON_TEXT_SAVE}
      </Button>
    </Box>
  );
};
export const LoginButton = (props) => {
  return (
    <>
      <Grid md={12} sm={12} xs={12} sx={props.styles.alignCenter}>
        <Button
          fullWidth
          type="submit"
          sx={props.styles.globalButton}
          variant={Constants.VARIANT_CONTAINED}
        >
          {Constants.BUTTON_HEADING_TEXT_LOGIN}
        </Button>
      </Grid>
    </>
  );
};

export const ResendCodeButton = (props) => {
  return (
    <>
      <Grid md={12} sm={12} xs={12} sx={props.styles.spaceBetween}>
        <Button
          fullWidth
          sx={props.styles.globalButton}
          type="submit"
          variant={Constants.VARIANT_CONTAINED}
          onClick={props.onClick}
        >
          {Constants.BUTTON_HEADING_TEXT_VERIFY}
        </Button>
      </Grid>
    </>
  );
};

export const DeleteDeactiveButton = (props) => {
  return (
    <Box display={"flex"} alignItems={"center"} gap="10px">
      <Button
        onClick={props.deactivate}
        sx={props.styles}
        variant={Constants.VARIANT_OUTLINED}
        disableElevation
        disabled={props.disabledDeativate}
      >
        {props?.is_active ? Constants.BUTTON_TEXT_DEACTIVATE : "Activate"}
      </Button>

      <Button
        fullWidth
        disableElevation
        onClick={props.delete}
        sx={props.styles}
        variant={Constants.VARIANT_CONTAINED}
        {...props}
      >
        {props?.is_deleted ? "Deleted" : Constants.BUTTON_TEXT_DELETE}
      </Button>
    </Box>
  );
};
